module.exports = __webpack_public_path__ + "assets/img/kanji.677bb60e.png";